package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_02_15_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to the Thardos family ruins and our heroes who have just defeated Do’shara, the blue dragon, masquerading as Samuel Thardos, Duke of Brij. An exhausted Bigglesworth limps over to Falorn’s side, sits on the ground, and stares up at him, waiting for healing. Falorn heals the wounded.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth watches the dragon’s corpse while Tuesday and Annette investigate the treasure chest, which is glowing with every school of magic — similar to previous Shards of Concar.  Tuesday carefully opens the treasure chest from a distance with his mage hand spell. Inside the chest are:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a Shard of Concar")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("four blue sapphires")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a star sapphire")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("an emerald")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("two fire opals")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a large pearl “of power”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a lump of coal - which turns out to be a Deodaris Diamond")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a magical “Sentinel” shield")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("magical javelins")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When Dirk adds the Shard of Concar to his bag of holding, the heroes hear a clicking noise, perhaps the shards connecting to each other. Tuesday thinks the Deodaris Diamond is ugly but reluctantly takes it on Caper’s advice.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram, Bigglesworth, and Falorn walk out to the fallen dragon. Goram carefully and precisely skins some dragon scales. While Bigglesworth lacks Goram’s patience, he is also able to skin several dragon scales. Falorn harvests dragon teeth.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes descend into the basement where they find a dozen cages, several of which have bones in them. On the east wall they see a defaces six-fingered hand mural. Goram sees two skeletons that might have been Evan and Rachel from Well’s Bounty. The heroes determine that the couple was likely butchered and skinned prior to rats and wildlife eating them. In a different cage beside a pile of bones, the heroes notice some fancy clothing. Goram picks up a scrap of the clothing, an emblem with the letter ‘B’ — perhaps this could be the remains of the authentic Duke of Brij. The heroes estimate that this person died two years ago. The heroes bury Evan, Rachel, and noble.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Reflecting on the noble’s body, the heroes search the guards’ bodies on the first floor. They find no maps or orders, and they conclude that these men were the Duke of Brij’s soldiers, likely unaware of the authentic Duke’s passing.")
    }
}
